/**
 * Basic marketing page wrapper — background, grain, top spacing for the fixed nav.
 */
export default function PageShell({ children, testid }) {
  return (
    <div className="relative bg-[#050510] text-white min-h-screen" data-testid={testid}>
      <div className="grain-overlay" aria-hidden="true" />
      {children}
    </div>
  );
}
